import React, {useContext} from 'react';
import LangContext from '../../context/LangContext';
import {Typography} from '@material-ui/core/';
import simhall1 from './Material/Simhall1.jpg';

export const Valloniadescription = (props) => {
  const [lang] = useContext(LangContext);
    return <>
      {lang==="se" ? <>
        <Typography variant="h5" gutterBottom>
        Vallonia och Korsholms simhall
        </Typography>
        Korsholms kommun planerar byggande av simhall vid Vallonia, utbygg av Vallonia skulle ge plats för bassängen.<br/><br/>
        <img style={{width: 320}} src={simhall1} alt="simhall" /><br/>
        </> : <>
        <Typography variant="h5" gutterBottom>
        Vallonia ja Mustasaaren Uimahalli
        </Typography>
        Mustasaaren kunta suunnittelee uimahallin rakentamista Vallonian yhteyteen. Vallonian laajennus antaisi tilaa uima-altaille.<br/><br/>
        <img style={{width: 320}} src={simhall1} alt="simhall" /><br/>
      </>}
  </>
};

export default Valloniadescription;